import { render, staticRenderFns } from "./addRelCaseDialog.vue?vue&type=template&id=734da720"
import script from "./addRelCaseDialog.vue?vue&type=script&lang=js"
export * from "./addRelCaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports